// extracted by mini-css-extract-plugin
export default {"text":"SGatb","mobile":"_1j4U5"};